import { Component, ViewEncapsulation } from '@angular/core';

/**
 * Empty component, this component is only used to supply styles without ViewEncapsulation as global styles
 * so that these classes can be passed into components as inputs and still be resolved
 */
@Component({
  selector: 'dgx-profile-global-styles',
  templateUrl: './profile-global-styles.component.html',
  styleUrls: ['./profile-global-styles.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProfileGlobalStylesComponent {
  constructor() {}
}
